<template>
  <CBottomPopup v-model="shown" title="修改POS单号" @closed="onClosed">
    <div class="pos-drawer-body">
      <div class="pos-drawer-form">
        <div class="pos-drawer-form-item">
          <CLabel required="">POS单号</CLabel>
          <CInput v-model="posNumber" placeholder="请输入内容" clearable :maxLength="30">
            <template #suffix>
              <div
                class="pos-prompt-scan-icon"
                @click="throttledOnScanPosClick"
              >
                <img src="@/assets/icons/scan-code.svg" alt="" /></div
            ></template>
          </CInput>
        </div>
        <div v-if="receiptNoVisible" class="pos-drawer-form-item">
          <CLabel>小票单号</CLabel>
          <CInput v-model="receiptNumber" placeholder="请输入内容" clearable :maxLength="30">
            <template #suffix>
              <div
                class="pos-prompt-scan-icon"
                @click="throttledOnScanReceiptClick"
              >
                <img src="@/assets/icons/scan-code.svg" alt="" />
              </div>
            </template>
          </CInput>
        </div>
      </div>
      <div class="pos-drawer-buttons c:row-center">
        <CButton small primary :disabled="confirmDisabled" @click="onConfirm"
          >确定</CButton
        >
      </div>
    </div>
  </CBottomPopup>
</template>

<script>
import CBottomPopup from "@/components/common/CBottomPopup.vue";
import CButton from "@/components/common/CButton.vue";
import CInput from "@/components/common/CInput.vue";
import CLabel from "@/components/common/CLabel.vue";
import { throttle } from "@/utils";
import { mapState } from "vuex";

export default {
  components: { CBottomPopup, CLabel, CInput, CButton },
  data() {
    return {
      shown: false,
      posNumber: "",
      receiptNumber: "",
    };
  },
  computed: {
    ...mapState(["brandInfo"]),
    receiptNoVisible() {
      return this.brandInfo.receiptNo?.enabled === true;
    },
    confirmDisabled() {
      return !this.posNumber;
    },
  },
  created() {
    this.throttledOnScanPosClick = throttle(this.onScanPos, 500);
    this.throttledOnScanReceiptClick = throttle(this.onScanReceipt, 500);
  },
  methods: {
    show(posNumber, receiptNumber) {
      return new Promise((resolve, reject) => {
        this._resolve = resolve;
        this._reject = reject;
        this.posNumber = posNumber;
        this.receiptNumber = receiptNumber;
        this.shown = true;
      });
    },
    onClosed() {
      if (this._reject) {
        this._reject();
        this._resolve = null;
        this._reject = null;
      }
    },
    onScanPos() {
      wx.scanQRCode({
        needResult: 1,
        desc: "扫POS码",
        scanType: ["qrCode", "barCode"],
        success: (res) => {
          console.log("onScanPos res", res);
          if (res.errMsg === "scanQRCode:ok") {
            console.log("onScanPos resultStr", res.resultStr);
            this.posNumber = res.resultStr;
          } else {
            console.log("onScanPos notOk", res.errMsg);
          }
        },
        fail: function (err) {
          console.error("onScanPos fail", err);
          if (err.errMsg.indexOf("function_not_exist") > 0) {
            this.$toast("版本过低请升级");
          }
        },
        error: function (err) {
          console.error("onScanPos error", err);
          if (err.errMsg.indexOf("function_not_exist") > 0) {
            this.$toast("版本过低请升级");
          }
        },
      });
    },
    onScanReceipt() {
      wx.scanQRCode({
        needResult: 1,
        desc: "扫小票单号",
        scanType: ["qrCode", "barCode"],
        success: (res) => {
          console.log("onScanPos res", res);
          if (res.errMsg === "scanQRCode:ok") {
            console.log("onScanPos resultStr", res.resultStr);
            this.receiptNumber = res.resultStr;
          } else {
            console.log("onScanPos notOk", res.errMsg);
          }
        },
        fail: function (err) {
          console.error("onScanPos fail", err);
          if (err.errMsg.indexOf("function_not_exist") > 0) {
            this.$toast("版本过低请升级");
          }
        },
        error: function (err) {
          console.error("onScanPos error", err);
          if (err.errMsg.indexOf("function_not_exist") > 0) {
            this.$toast("版本过低请升级");
          }
        },
      });
    },
    onConfirm() {
      if (!/^[\da-z]+$/i.test(this.posNumber)) {
        this.$toast("只能输入字母或数字");
        return;
      }
      if (this._resolve) {
        this._resolve({
          posNumber: this.posNumber,
          receiptNumber: this.receiptNumber || "",
        });
        this._resolve = null;
        this._reject = null;
      }
      this.shown = false;
    },
  },
};
</script>

<style lang="less" scoped>
.pos-drawer-body {
  .pos-drawer-form {
    min-height: 200/20rem;
    padding: 0 20/20rem;

    &-item {
      margin-bottom: 16/20rem;
      &:last-of-type {
        margin-bottom: 0;
      }
    }

    .pos-prompt-scan-icon {
      width: 40/20rem;
      height: 38/20rem;
      padding: 8/20rem 9/20rem;
      img {
        width: 22/20rem;
        height: 22/20rem;
      }
    }
  }

  .pos-drawer-buttons {
    gap: 12/20rem;

    margin-top: 16/20rem;
    padding: 8/20rem 20/20rem 20/20rem;
  }
}
</style>
